import { render, staticRenderFns } from "./PasswordRulesMessage.vue?vue&type=template&id=54930d34"
import script from "./PasswordRulesMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordRulesMessage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports